export function propertyClassLabel(property_class) {
  switch (property_class) {
    case "A":
      return "AGRICULTURE";
    case "A, AD":
      return "AGRICULTURE, AG DWELLING";
    case "A, AD, RE":
      return "AGRICULTURE, AG DWELL, RESIDENTIAL";
    case "A, RE":
      return "AGRICULTURE, RESIDENTIAL";
    case "AD, RE":
      return "AG DWELL, RESIDENTIAL";
    case "AD, C":
      return "AG DWELL, COMMERCIAL";
    case "CO":
      return "COMMERCIAL";
    case "C":
      return "COMMERCIAL";
    case "CO, RE":
      return "COMMERCIAL, RESIDENTIAL";
    case "C, RE":
      return "COMMERCIAL, RESIDENTIAL";
    case "C, M":
      return "COMMERCIAL, MULTI-RESIDENTIAL";
    case "IN":
      return "INDUSTRIAL";
    case "I":
      return "INDUSTRIAL";
    case "M":
      return "MULTI-RESIDENTIAL";
    case "RE":
      return "RESIDENTIAL";
    default:
      return property_class;
  }
}

export function parcelsTemplate({
  render_auditor,
  current_tax_year,
  auditor_tax_year,
  past_tax_year,
  domain,
}) {
  return `
    <div>
      <div style="text-align: center;">
        <img id="popup_image" src="${domain}/apps/gma/property_photo/{gid}" >
      </div>

      <div style="margin: 2px;">
  
      <h4>Property Information</h4>
  
      <table class="esri-widget__table" summary="List of attributes and values">
        <tbody>
            <tr>
              <th class="third">Parcel</th>
              <td class="two-third">{PARCEL_NO}</td>
            </tr>
            <tr>
              <th class="third">Owner</th>
              <td class="two-third">{OwnerName}</td>
            </tr>
            <tr>
              <th class="third">Contract To</th>
              <td class="two-third">{CONTRACTTO}</td>
            </tr>
            <tr>
              <th class="third">Site Address</th>
              <td class="two-third">{SiteAdd}</td>
            </tr>
            <tr>
              <th class="third">Mail Address</th>
              <td class="two-third">{MailAdd}</td>
            </tr>
          </tbody>
        </table>

        <table class="esri-widget__table" style="margin-top: 0.5em" summary="List of attributes and values">
          <tbody>
            <tr>
              <th class="half" colspan="2">Property Class</th>
              <th class="half" colspan="2">Net Acres</th>
            </tr>
            <tr>
              <td class="half" colspan="2">{PropertyClass}</td>
              <td class="half" colspan="2">{NetAcre}</td>
            </tr>
            <tr>
              <th class="half" colspan="2">Zoning Authority</th>
              <th class="half" colspan="2">Zoning District</th>
            </tr>
            <tr>
              <td class="half" colspan="2">{ZoneAuthor}</td>
              <td class="half" colspan="2">{LandUseZon}</td>
            </tr>
          </tbody>
        </table>
          
      <h4>Legal Information</h4>
  
      <table class="esri-widget__table" summary="List of attributes and values">
        <tbody>
          <tr>
            <th>Deed Book</th>
            <td>{DeededBook}</td>
          </tr>
          <tr>
            <th>Deed Page</th>
            <td>{DeededPage}</td>
          </tr>
          <tr>
            <th>Instrument Number</th>
            <td>{DeededInst}</td>
          </tr>
          <tr>
            <th colspan="2">Legal</th>
          </tr>
          <tr>
            <td colspan="2">{Legal}</td>
          </tr>
        </tbody>
      </table>
  
      <h4>${current_tax_year} Assessed Values</h4>
  
      <table class="esri-widget__table" summary="List of attributes and values">
        <tbody>
          <tr>
            <th class="quarter">Building</th>
            <th class="quarter">Dwelling</th>
            <th class="quarter">Land</th>
            <th class="quarter">Total</th>
          </tr>
          <tr>
            <td class="quarter">\${Building_A}</td>
            <td class="quarter">\${Dwelling_A}</td>
            <td class="quarter">\${Land_A}</td>
            <td class="quarter">\${Total_A}</td>
          </tr>
          <tr>
            <th class="half" colspan="2">Exempt Value</th>
            <th class="half" colspan="2">Full Value</th>
          </tr>
          <tr>
            <td class="half" colspan="2">\${ExTotal}</td>
            <td class="half" colspan="2">\${FullVal}</td>
          </tr>
        </tbody>
      </table>
  
      ${render_auditor ? 
        `<h4>${auditor_tax_year} Assessed Values</h4>
    
        <table class="esri-widget__table" summary="List of attributes and values">
          <tbody>
            <tr>
              <th class="quarter">Building</th>
              <th class="quarter">Dwelling</th>
              <th class="quarter">Land</th>
              <th class="quarter">Total</th>
            </tr>
            <tr>
              <td class="quarter">\${Build_AA}</td>
              <td class="quarter">\${Dwell_AA}</td>
              <td class="quarter">\${Land_AA}</td>
              <td class="quarter">\${Total_AA}</td>
            </tr>
            <tr>
              <th class="half" colspan="2">Exempt Value</th>
              <th class="half" colspan="2">Full Value</th>
            </tr>
            <tr>
              <td class="half" colspan="2">\${ExTotal_AA}</td>
              <td class="half" colspan="2">\${FullTlt_AA}</td>
            </tr>
          </tbody>
        </table>` : ""
      }
  
  
      <h4>${past_tax_year} Assessed Values</h4>
  
      <table class="esri-widget__table" summary="List of attributes and values">
        <tbody>
          <tr>
            <th class="quarter">Building</th>
            <th class="quarter">Dwelling</th>
            <th class="quarter">Land</th>
            <th class="quarter">Total</th>
          </tr>
          <tr>
            <td class="quarter">\${Building_T}</td>
            <td class="quarter">\${Dwelling_T}</td>
            <td class="quarter">\${Land_T}</td>
            <td class="quarter">\${Total_T}</td>
          </tr>
        </tbody>
      </table>
  
      <h4>Taxes, Credits, and Rates</h4>
  
      <table class="esri-widget__table" summary="List of attributes and values">
        <tbody>
          <tr>
            <td colspan="2">Disticts and Levy Rates</td>
          </tr>
          <tr>
            <td colspan="2">{DistrictsA}</td>
          </tr>
          <tr>
            <th>Net Taxes</th>
            <td>\${NetTax}</td>
          </tr>
          <tr>
            <th>Family Farm</th>
            <td>\${FamFarm}</td>
          </tr>
          <tr>
            <th>Gross Tax</th>
            <td>\${GrossTax}</td>
          </tr>
          <tr>
            <th>DSC Credit</th>
            <td>\${DSC_Tax}</td>
          </tr>
          <tr>
            <th>Homestead Credit</th>
            <td>{HomesteadT}</td>
          </tr>
          <tr>
            <th>Ag Land</th>
            <td>\${Ag_Land}</td>
          </tr>
          <tr>
            <th>Drainage</th>
            <td>\${DrainageT}</td>
          </tr>
        </tbody>
      </table>
  
      <div class="ui divider"></div>

  
      <div class="ui two column no-margin grid">
        <div class="column" style="padding-top: .5rem;padding-bottom: .25rem;padding-left: .25rem;padding-right: .25rem;">
          <a href="https://desmoines.iowaassessors.com/parcel/{ParcelNumb}"} target="_blank" class="ui fluid small button">
            <i class="external icon"></i>
            Assessor Info
          </a>
        </div>
        <div class="column" style="padding-top: .5rem;padding-bottom: .25rem;padding-left: .25rem;padding-right: .25rem;">
          <a href="https://www.iowatreasurers.org/parceldetail.php?idCounty=29&parcel={PARCEL_NO}"} target="_blank" class="ui fluid small button">
            <i class="external icon"></i>
            Treasurer Info
          </a>
        </div>
      </div>
    
      <div class="ui one column no-margin grid">
        <div class="column" style="padding-top: .5rem;padding-bottom: .25rem;padding-left: .25rem;padding-right: .25rem;">
          <a href="https://www.dmcgis.com/images/Prints/Parcel_{ParcelNumb}.pdf"} target="_blank" class="ui fluid small button">
            <i class="file pdf icon"></i>
            Property Report
          </a>
        </div>
      </div>
      </div>
    </div>`;
}
